export default "__VITE_ASSET__CO4b406o__"